/**
 * Shared helpers for the challenge/series app hand-off landing pages
 * (`ChallengeLanding.svelte` / `SeriesLanding.svelte`): game-key label
 * mapping and human-readable expiry countdown. The backend `game_key` enum
 * (`ai_vs_you` | `track_detective` | `underground`) uses underscores.
 */

const GAME_LABELS: Record<string, string> = {
  ai_vs_you: 'AI vs You',
  track_detective: 'Track Detective',
  underground: 'Underground or Mainstream',
};

export function gameLabel(key: string): string {
  return GAME_LABELS[key] ?? key;
}

/** Human-readable "expires in Xd/Xh/<1h/expired" from an ISO date. */
export function expiresIn(isoDate: string): string {
  const diffMs = new Date(isoDate).getTime() - Date.now();
  if (diffMs <= 0) return 'expired';
  const days = Math.floor(diffMs / 86_400_000);
  if (days > 1) return `${days}d`;
  const hrs = Math.floor(diffMs / 3_600_000);
  if (hrs > 1) return `${hrs}h`;
  return '<1h';
}
